<template>
  <main id="content" role="main">

    <!-- Content Section -->
    <div class="container space-1 space-top-lg-0 space-bottom-lg-2">
      <div class="row">
        <div class="col-lg-3">
          <!-- Navbar -->
          <div class="navbar-expand-lg navbar-expand-lg-collapse-block navbar-light">
            <div id="sidebarNav" class="collapse navbar-collapse navbar-vertical">
              <!-- Card -->
              <div class="card mb-5">
                <div class="card-body">


                  <!-- Nav -->
                  <h5 class="text-cap small text-uppercase text-danger">Mes informations</h5>

                  <!-- List -->
                  <ul class="nav nav-sub nav-sm nav-tabs nav-list-y-2 mb-4">


                    <li class="nav-item">
                      <a class="nav-link " href="./preferences.html">
                        <i class="fas fa-sliders-h nav-icon"></i> Paramètrage de la plateforme
                      </a>
                    </li>




                    <li class="nav-item">
                      <a class="nav-link " href="./reservations.html">
                        <i class="fas fa-book nav-icon"></i> Boutiques (Admin)
                      </a>
                    </li>







                  </ul>
                  <!-- End List -->

                  <h6 class="text-cap small text-uppercase text-danger">Mes participations</h6>

                  <!-- List -->
                  <ul class="nav nav-sub nav-sm nav-tabs nav-list-y-2 mb-4">
                    <li class="nav-item">
                      <a class="nav-link" :class="{active: participation_tab == 0}" href="javascript:;" @click="participation_tab = 0">
                        <i class="fas fa-heart nav-icon"></i> Taxe d'apprentissage
                      </a>
                    </li>

                    <li class="nav-item">
                      <a class="nav-link" :class="{active: participation_tab == 1}" href="javascript:;" @click="participation_tab = 1">
                        <i class="fas fa-donate nav-icon"></i> Documents partagés
                      </a>
                    </li>
                  </ul>
                  <!-- End List -->


                  <h6 class="text-cap small text-uppercase text-danger">
                    Aide</h6>

                  <!-- List -->
                  <ul class="nav nav-sub nav-sm nav-tabs nav-list-y-2 mb-4">


                    <li class="nav-item">
                      <a class="nav-link" href="./contact-account.html" id="pass-Modal">
                        <i class="fas fa-phone nav-icon"></i> Contacter le support
                      </a>
                    </li>



                  </ul>
                  <!-- End List -->



                  <div class="dropdown-divider"></div>

                  <!-- List -->
                  <ul class="nav nav-sub nav-sm nav-tabs nav-list-y-2">

                    <li class="nav-item">
                      <a class="nav-link text-danger" href="./deleteaccount.html">
                        <i class="fas fa-ban nav-icon"></i> Suppression de compte
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link text-primary" href="disconnect.html">
                        <i class="fas fa-sign-out-alt nav-icon"></i> Me deconnecter
                      </a>
                    </li>
                  </ul>
                  <!-- End List -->

                  <!-- End Nav -->
                </div>
              </div>
              <!-- End Card -->
            </div>
          </div>
          <!-- End Navbar -->
        </div>

        <div class="col-lg-9">
          <div v-if="participation_tab == 0">
            <div class="card">
              <div class="card-body">
                <div class="d-lg-flex align-items-end">
                  <div class="col-lg-8">
                    <label>Rechercher :</label>
                    <input type="search" class="form-control">
                  </div>

                  <div class="col-lg-4">
                    <!--Ici il faut rattacher le formulaire demande de versement de taxe (avec le n° de siret, etc..) -->
                    <a href="../form-taxe.html" class="btn btn-primary">Nouvelle demande</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="card p-0 mt-3">
              <!-- Table -->
              <div class="table-responsive w-100 py-4">
                <table class="table table-borderless table-thead-bordered table-nowrap table-align-middle mb-0">
                  <thead class="thead-light">
                  <tr>
                    <th>Établissement</th>
                    <th>Alternant</th>
                    <th>Formation</th>
                    <th style="width: 5px ;">Personne à contacter</th>
                    <th>Date de fin</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>École des mines</td>
                    <td><a href="#">Antoine Ducasse</a></td>
                    <td><span class="badge badge-soft-warning">Manager</span></td>
                    <td><a class="btn btn-xs btn-white" href="#"><i class="fas fa-phone mr-1"></i> Contacter</a></td>
                    <td>22/04/2020</td>

                  </tr>

                  </tbody>
                </table>
              </div>
              <!-- End Table -->
            </div>
          </div>

          <div v-if="participation_tab == 1" class="card p-3 mt-3">
            <!-- Title -->
            <div class="mb-3 d-flex align-items-center justify-content-between">
              <h2 class="h4 mb-0">Documents Partagés</h2>
            </div>
            <!-- End Title -->

            <div class="row">

              <div class="col-sm-6 col-lg-4 mb-3">
                <!-- Blog Card -->
                <article class="card shadow-lg border h-100">
                  <div class="card-body pb-0">

                    <h3 class="h5 mb-0"><a href="#">Lettre d'intention de versement</a></h3>
                    <img src="/modules/testmaquette/img/pdf.png" class="img-fluid w-30 mt-4">

                  </div>
                  <div class="card-footer border-0 pt-3">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <small class="d-block">Laurie Paris</small>
                        <small class="d-block">July 15</small>
                      </div>

                    </div>
                  </div>
                </article>
                <!-- End Blog Card -->
              </div>

              <div class="col-sm-6 col-lg-4 mb-3">
                <!-- Blog Card -->
                <article class="card shadow-lg border h-100">
                  <div class="card-body pb-0">


                    <h3 class="h5 mb-0"><a href="#">Reçu_Libératoire.pdf</a></h3>
                    <img src="/modules/testmaquette/img/pdf.png" class="img-fluid w-30 mt-4">


                  </div>
                  <div class="card-footer border-0 pt-3">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <small class="d-block">Laurie Paris</small>
                        <small class="d-block">July 15</small>
                      </div>

                    </div>
                  </div>
                </article>
                <!-- End Blog Card -->
              </div>

              <div class="col-sm-6 col-lg-4 mb-3">
                <!-- Blog Card -->
                <article class="card shadow-lg border h-100">
                  <div class="card-body pb-0">


                    <h3 class="h5 mb-0"><a href="#">Bandeaux_Taxe.pdf</a></h3>
                    <img src="/modules/testmaquette/img/pdf.png" class="img-fluid w-30 mt-4">

                  </div>
                  <div class="card-footer border-0 pt-3">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <small class="d-block">Laurie Paris</small>
                        <small class="d-block">July 15</small>
                      </div>

                    </div>
                  </div>
                </article>
                <!-- End Blog Card -->
              </div>


            </div>
          </div>
        </div>
      </div>
      <!-- End Row -->
    </div>

  </main>
</template>

<script>
export default {
  name: "DlnkTaxeComptePartenaire",

  data: function () {
    return {
      participation_tab: 0,
    }
  }
}
</script>

<style scoped>

</style>